export const FILE_UPLOAD_NOTICE = '파일 첨부 시 아래 사항을 확인해주세요.';
